import React from 'react';

// tslint:disable:max-line-length
const AttachmentIcon = (props) => (
  <svg width={12} height={12} viewBox="0 0 12 12" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M1.42 6.34l1.917-1.916L5.08 2.68c1.202-1.202 2.56-1.299 3.896.036 1.193 1.193 1.339 2.477.293 3.523l-3.12 3.12c-1.236 1.236-1.78 1.21-2.622.367-.888-.888-.795-1.624-.18-2.24L4.86 5.974l1.557-1.556c.31-.31.615-.365.834-.146.242.243.236.434-.065.735L5.76 6.434 4.27 7.922a.75.75 0 0 0 1.06 1.06c.373-.371.373-.371 1.488-1.487l1.428-1.428c.872-.871.908-2.012.064-2.856-.904-.904-2.124-.684-2.955.146L3.8 4.913 2.286 6.427c-1.15 1.151-1.361 2.82.18 4.36 1.407 1.408 2.898 1.48 4.744-.366l3.12-3.12c1.69-1.692 1.44-3.912-.293-5.644C8.079-.301 5.776-.137 4.019 1.62L2.277 3.363.359 5.28a.75.75 0 0 0 1.06 1.06z"
    />
  </svg>
);
// tslint:enable:max-line-length

export default AttachmentIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/AttachmentIcon.js